import React from "react";
import PropTypes from "prop-types";

import {DateParser} from "../../services/date";
import {ResponsiveDialog} from "../../components/ResponsiveDialog";
import OfferDetails from "./OfferDetails";

const OfferDetailsDialog = props => {
    const {offer, homes, onClose} = props;
    const {
        titleIt,
        titleEn,
        descriptionIt,
        descriptionEn,
        startDate,
        endDate,
        price,
        minPeople,
        minNight,
        petsAllowed,
        apartment,
    } = offer;

    let home;

    for (let h of homes) {
        for (let a of h["apartments"]) {
            if (a["id"] === apartment["id"]) {
                home = h;
            }
        }
    }

    const pictureUrl = home && home["icon"] ? home["icon"] : null;
    const homeName = home && home["name"] ? home["name"] : "HOME_NAME";
    const apartmentName = apartment && apartment["name"] ? apartment["name"] : "APARTMENT_NAME";

    return (
        <ResponsiveDialog title="Dettagli offerta"
                          maxWidth="md"
                          isOpen={true}
                          closeLabel="Ok"
                          onClose={onClose}>

            <OfferDetails titleIt={titleIt}
                          titleEn={titleEn}
                          descriptionIt={descriptionIt}
                          descriptionEn={descriptionEn}
                          startDate={DateParser.safeParseISO(startDate, null)}
                          endDate={DateParser.safeParseISO(endDate, null)}
                          price={parseFloat(price)}
                          minPeople={minPeople}
                          minNight={minNight}
                          petsAllowed={petsAllowed}
                          pictureUrl={pictureUrl}
                          homeName={homeName}
                          apartmentName={apartmentName}/>
        </ResponsiveDialog>
    )
};

OfferDetailsDialog.propTypes = {
    offer: PropTypes.object.isRequired,
    homes: PropTypes.arrayOf(PropTypes.object).isRequired,
    onClose: PropTypes.func.isRequired,
};

export default OfferDetailsDialog;